// extracted by mini-css-extract-plugin
export default {"sticker":"TY_nyPoa","buttons":"JuY14PzG","button":"e8xjMuq6","cexInfoBlock":"ETTMopFT","cexDescription":"py5PsFcp","cexDescriptionBold":"klHFON2R","cexTextField":"f3Hj9xW9"};